<template>
  <div class='pull-down-container'>
    <div class='pull-down-header d-lg-none' v-bind:style="{height: pullDown.height + 'px'}">
      <div class='pull-down-content' :style='pullDownContentStyle'>
        <i class='pull-down-content--icon' v-bind:class='iconClass'>
          <Icon icon-name="arrow-circle-down-outline" class=""></Icon>
        </i>
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
import Icon from '@shared/components/Icon'
const STATUS_ERROR = -1
const STATUS_START = 0
const STATUS_READY = 1
const STATUS_REFRESH = 2

const ANIMATION = 'height .2s ease'
const TOPNAV_HEIGHT = 180

export default {
  props: {
    onRefresh: {
      type: Function
    },
    config: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  components: { Icon },
  data() {
    return {
      pullDown: {
        status: 0,
        height: 0,
        msg: ''
      },
      canPull: false
    }
  },
  computed: {
    iconClass() {
      if (this.pullDown.status === STATUS_REFRESH) {
        return 'pull-down-refresh'
      } else if (this.pullDown.status === STATUS_ERROR) {
        return 'pull-down-error'
      }
      return ''
    },
    pullDownContentStyle() {
      return {
        bottom: (this.config.pullDownHeight - 40) / 2 + 'px'
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      const el = this.$el
      const pullDownHeader = el.querySelector('.pull-down-header')
      const icon = pullDownHeader.querySelector('.pull-down-content--icon')
      this.config.pullDownHeight = this.config.pullDownHeight || 60

      const resetPullDown = (pullDown, withAnimation) => {
        if (withAnimation) {
          pullDownHeader.style.transition = ANIMATION
        }
        pullDown.height = 0
        pullDown.status = STATUS_START
      }

      const touchPosition = {
        start: 0,
        distance: 0
      }

      let supportsPassive = false
      try {
        const opts = Object.defineProperty({}, 'passive', {
          get: function () {
            supportsPassive = true
          }
        })
        window.addEventListener('test', null, opts)
      } catch (e) {}

      el.addEventListener('touchstart', e => {
        this.canPull = el.scrollTop === 0
        touchPosition.start = e.touches.item(0).pageY
      }, supportsPassive ? { passive: true } : false)

      el.addEventListener('touchmove', e => {
        if (!this.canPull) {
          return
        }
        let distance = e.touches.item(0).pageY - touchPosition.start
        distance = distance > TOPNAV_HEIGHT ? TOPNAV_HEIGHT : distance

        touchPosition.distance = distance
        this.pullDown.height = distance

        if (distance > this.config.pullDownHeight) {
          this.pullDown.status = STATUS_READY
          icon.style.transform = 'rotate(180deg)'
        } else {
          this.pullDown.status = STATUS_START
          icon.style.transform = 'rotate(' + distance / this.config.pullDownHeight * 180 + 'deg)'
        }
      }, supportsPassive ? { passive: true } : false)

      el.addEventListener('touchend', e => {
        this.canPull = false
        pullDownHeader.style.transition = ANIMATION
        icon.style.transform = ''

        if (touchPosition.distance - el.scrollTop > this.config.pullDownHeight) {
          el.scrollTop = 0
          this.pullDown.height = this.config.pullDownHeight
          this.pullDown.status = STATUS_REFRESH
          if (this.onRefresh && typeof this.onRefresh === 'function') {
            const res = this.onRefresh()
            if (res && res.then && typeof res.then === 'function') {
              res.then(result => {
                resetPullDown(this.pullDown, true)
              }, error => {
                if (typeof error !== 'string') {
                  error = false
                }
                this.pullDown.msg = error || 'Loading failed'
                this.pullDown.status = STATUS_ERROR
                setTimeout(() => {
                  resetPullDown(this.pullDown, true)
                }, 1000)
              })
            } else {
              resetPullDown(this.pullDown)
            }
          } else {
            resetPullDown(this.pullDown)
          }
        } else {
          resetPullDown(this.pullDown)
        }
        touchPosition.distance = 0
        touchPosition.start = 0
      })
      pullDownHeader.addEventListener('transitionend', () => {
        pullDownHeader.style.transition = ''
      })
      pullDownHeader.addEventListener('webkitTransitionEnd', () => {
        pullDownHeader.style.transition = ''
      })
    })
  }
}
</script>
